<!-- Marketplace search results (mobile) -->
<a class="fmp mps" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <app-meta-creative class="fmp-image mps-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  <div class="mps-copy">
    <div class="mps-page">
      <img class="mps-avatar" [src]="avatar" alt="" />
      <span class="fmp-ellipsis">{{ pageName }}</span>
      <i class="bi bi-three-dots mps-menu"></i>
    </div>
    <div class="fmp-clamp mps-headline">{{ headline }}</div>
    <div class="fmp-muted mps-label">Sponsored</div>
  </div>
</a>
